export default __webpack_public_path__ + "static/media/book_6.6c75c227.svg";